import React, { useEffect } from 'react';
import { IConciergeEmbedChatData } from 'interfaces/concierge';
import { useConciergeEmbedChatData } from 'hooks/useConciergeEmbedChatData';
import AiLiveChat from 'components/Global/AiLiveChat/AiLiveChat';

const ConciergeAiEmbedChat = (): JSX.Element => {
  const queryKey = `/platform/api/v1/concierge/embedded-chat`;
  const { status, data } = useConciergeEmbedChatData(queryKey);
  const isHonda = process.env.REACT_APP_THEME === 'honda';

  const conciergeEmbedChat: IConciergeEmbedChatData =
    data as IConciergeEmbedChatData;

  useEffect(() => {
    const containerDisplay = isHonda ? 'block' : 'flex';
    const onlineElement = document.getElementById(
      'liveagent_button_online_573o0000000PHe3'
    );
    const offlineElement = document.getElementById(
      'liveagent_button_offline_573o0000000PHe3'
    );
    if (onlineElement && offlineElement) {
      onlineElement.style.display = 'none';
      offlineElement.style.display = containerDisplay;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  switch (status) {
    case 'error':
      return <></>;
    case 'success':
      return <AiLiveChat data={conciergeEmbedChat.embeddedAiChatResponse} />;
    default:
      return <></>;
  }
};

export default ConciergeAiEmbedChat;
